module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0107-small-c370a2a27964abe2e1e2cfa6c6935dd7.png";